/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_DINERO,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React, {useContext, useEffect, useRef, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {METODOBONO, TIPOMOVIMIENTO} from "../../Constantes";
import Dialogo_Movimiento from "../Dialogos/Caja/Dialogo_Movimiento";
import ic_caja from '../../Modulo_Graficas/RecursosGraficas/ic_caja.svg'
import ic_cartera from '../../Modulo_Graficas/RecursosGraficas/ic_cartera.svg'
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Tarjeta_Indicador from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Indicador";
import {where} from "firebase/firestore";
import {contarWheresSuma} from "../../Servicios/BD/Contadores/contarWheresSuma";
import {ESTADOSRESERVAS} from "../../Modulo_Motor_Reservas/Constantes";
import {formatoMonedaGraficasDisminuido} from "../../Modulo_Graficas/Utilidades/formatoMonedaGraficasDisminuido";
import Titulo_Dos_Datos from "../../Modulo_Graficas/Componentes/Titulos/Titulo_Dos_Datos";
import {usuarioContext} from "../../App";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import ExportadorDatosCaja from "../Componentes/ExportadorDatosCaja";


const Seccion_Caja = () => {
    const {sCell} = useResponsive()
    const refe = useRef()
    const altoGraficas = 160
    const {alto} = useObtenerAlto({contenedor: refe})
    const [totalCaja, setTotalCaja] = useState([])
    const [totalCartera, setTotalCartera] = useState([])
    const [ingresosHoy, setIngresosHoy] = useState(0)
    const [egresosHoy, setEgresosHoy] = useState(0)
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025({coleccion: 'cajaMovimientos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Movimiento,
        titulo: 'Detalles del movimiento',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }

    const obtenerDatos = async () => {

        let wIngresosEfectivo = [where('tipo', '==', TIPOMOVIMIENTO[0].nombre), where('metodo', '==', METODOBONO[0])]
        let wEgresos = [where('tipo', '==', TIPOMOVIMIENTO[1].nombre)]

        let ingresosEfectivo = await contarWheresSuma({
            coleccion: 'cajaMovimientos',
            propiedad: 'valor',
            wheres: wIngresosEfectivo
        })
        let egresos = await contarWheresSuma({coleccion: 'cajaMovimientos', propiedad: 'valor', wheres: wEgresos})

        setTotalCaja(ingresosEfectivo.data - egresos.data)


        let fecha_ = new Date()
        let fechaHoy = new Date(fecha_.getFullYear(), fecha_.getMonth(), fecha_.getDate(), 0, 0, 1).getTime()

        let wIngresosHoy = [where('tipo', '==', TIPOMOVIMIENTO[0].nombre), where('fecha', '>=', fechaHoy)]
        let wEgresosHoy = [where('tipo', '==', TIPOMOVIMIENTO[1].nombre), where('fecha', '>=', fechaHoy)]


        let ingresoHoy = await contarWheresSuma({
            coleccion: 'cajaMovimientos',
            propiedad: 'valor',
            wheres: wIngresosHoy
        })
        let egresosHoy = await contarWheresSuma({coleccion: 'cajaMovimientos', propiedad: 'valor', wheres: wEgresosHoy})

        setIngresosHoy(ingresoHoy.data)
        setEgresosHoy(egresosHoy.data)

        let wCartera = [where('estado', '==', ESTADOSRESERVAS[4])]
        let cartera = await contarWheresSuma({coleccion: 'reservas', propiedad: 'valorSaldo', wheres: wCartera})
        setTotalCartera(cartera.data)
    }


    useEffect(() => {
        obtenerDatos()
    }, []);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Titulo_Dos_Datos titulo={'Estado de Caja'} usuario={usuario} textoUno={'Ingresos Hoy'}
                                      textoDos={'Egresos Hoy'}
                                      datoUno={formatoMonedaGraficasDisminuido(ingresosHoy)}
                                      datoTres={formatoMonedaGraficasDisminuido(egresosHoy)}/>
                </Grid>

                <Grid container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Indicador icono={ic_caja} titulo={'Efectivo en caja'}
                                       valor={formatoMonedaGraficasDisminuido(totalCaja)}/>
                </Grid>

                <Grid container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Indicador icono={ic_cartera} color={'#7E7850'} titulo={'Total en cartera'}
                                       valor={formatoMonedaGraficasDisminuido(totalCartera)}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? -19 : 0}}>
                    <Tabla_Filtro
                        nombre={'Movimientos en caja'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                       // ComponenteInferior={ExportadorDatosCaja}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Caja

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Descripcion',
        direccion: 'left',
        propiedad: 'descripcion',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        tipo: CASILLA_DINERO

    },
    {
        nombre: 'Metodo',
        direccion: 'left',
        propiedad: 'metodo',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Tipo',
        direccion: 'right',
        propiedad: 'tipo',
        tipo: CASILLA_ESTADO,
        estados: TIPOMOVIMIENTO
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]